import {createModel} from '@@/package/utils/ModelUtil';

export class CodeCustomFunctionModel {
    constructor(
        public path: string,
        public functions: string[]
    ) {
    }

    public static create(model: Partial<CodeCustomFunctionModel>): CodeCustomFunctionModel {
        return createModel<CodeCustomFunctionModel>(CodeCustomFunctionModel, {
            ...model
        });
    }
}
